module.exports = __webpack_public_path__ + "static/media/marker.666202ee.svg";